<template>
  <v-main class="tpadding">
    <v-container fluid>
      <v-card class="rounded-xl elevation-5">
        <v-toolbar dense dark color="pinkKonect" elevation="2">
          <v-toolbar-title>Reporte de pasajeros y rutas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn :disabled="items == 0" elevation="0" text small :loading="loading">
            <xlsx-workbook>
              <xlsx-sheet :collection="sheet.data" v-for="sheet in sheetsGeneral" :key="sheet.name" :sheet-name="sheet.name" />
              <xlsx-download :filename="'Reporte ' + this.reportTypeGeneral + '.xlsx'">
                <button>DESCARGAR</button>
                <v-icon right>mdi-microsoft-excel</v-icon>
              </xlsx-download>
            </xlsx-workbook>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row no-gutters class="mb-8">
            <v-col :cols="$vuetify.breakpoint.mobile ? 6 : 1">
              <v-dialog ref="dialogBegin" v-model="modalBegin" :return-value.sync="begin" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="begin"
                    label="Fecha de inicio"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                    class="pr-2"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="begin" scrollable locale="es">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalBegin = false"> Cancel </v-btn>
                  <v-btn text color="primary" @click="$refs.dialogBegin.save(begin)"> OK </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 6 : 1">
              <v-dialog ref="dialogEnd" v-model="modalEnd" :return-value.sync="begin" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="end"
                    label="Fecha fin"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                    class="pr-2"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="end" scrollable locale="es">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalEnd = false"> Cancel </v-btn>
                  <v-btn text color="primary" @click="$refs.dialogEnd.save(end)"> OK </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 6 : 1">
              <v-autocomplete
                v-model="turnSearch"
                :items="turnItem"
                label="Turno"
                prepend-icon="mdi-clock-outline"
                clearable
                :disabled="loading"
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 6 : 2">
              <v-text-field class="pl-8" v-model="search" label="Buscar" single-line hide-details clearable></v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 6 : 7" right class="d-flex mt-2" style="justify-content: right">
              <v-btn :disabled="!isReading" small center outlined color="blueKonect" class="mx-2 mt-auto" elevation="0" @click="refresh()">
                Consultar
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
              <v-btn
                :disabled="!isReading"
                small
                center
                outlined
                color="blueKonect"
                class="mx-2 mt-auto"
                elevation="0"
                @click="noAccessReport()"
              >
                Reporte de no acceso
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :search="search"
            :items-per-page="5"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              itemsPerPageAllText: 'Todos',
            }"
          >
            <template v-slot:item.estado="{ item }">
              <v-chip v-if="item.estado || item.registered" small rounded outlined color="success" dark>Activo</v-chip>
              <v-chip v-else small rounded outlined color="error">Inactivo</v-chip>
            </template>
            <template v-slot:item.create="{ item }">
              <span v-text="date(item.fecha_creacion)"></span>
            </template>
            <template v-slot:item.employee_name="{ item }">
              <span
                v-text="
                  (item.nombre_empleado ? item.nombre_empleado : '') +
                  ' ' +
                  (item.apellido_empleado ? item.apellido_empleado : '') +
                  ' ' +
                  (item.apellido_materno ? item.apellido_materno : '')
                "
              />
            </template>
            <template v-slot:item.route_name="{ item }">
              <span
                v-text="
                  item.ruta_idruta +
                  ' ' +
                  item.ruta_nombre_ruta +
                  ' ' +
                  (item.servicio != '' ? (item.tipo_servicio == 'M' ? 'Mete' : 'Saca') : '')
                "
              />
            </template>
            <template v-slot:item.action="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-tooltip :disabled="!item.estado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="mr-2" :color="!item.estado ? 'grey' : 'error'" dark v-bind="attrs" v-on="on" @click="remove(item)">
                        mdi-account-remove
                      </v-icon>
                    </template>
                    <span>desactivar</span>
                  </v-tooltip>
                </template>
                <span>Desactivar acceso</span>
              </v-tooltip>
            </template>
            <template v-slot:[`footer.page-text`]="props">
              Página {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-data> No hay información disponible </template>
            <template v-slot:no-results> No se obtuvieron resultados </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <simpleDialog :active="dialogs.remove" :clickRemove="remove" :clickCancel="cancel" :removeMsg="msgRemove" btnMsgRemove="Aceptar" />
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right style="white-space: pre-line">
        {{ errorList[codeError] }}
        {{ "\n\n" + this.codeError }}
      </v-snackbar>
      <errormsg :onFinish="closeMsg" :show="error" :message="codeError" colorMsg="error" alignX="bottom" alignY="right" />
    </v-container>
  </v-main>
</template>

<script>
import services from "@/utils/services";
import { tablek, errormsg, simpleDialog, csvButton } from "@/components";
import moment_tz from "moment-timezone";
import moment from "moment";
import errorList from "@/utils/errorsList";
import { XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx";

export default {
  name: "Clientes",
  components: {
    tablek,
    errormsg,
    simpleDialog,
    csvButton,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data: () => ({
    visible: false,
    loading: false,
    success: false,
    errorList,
    msgSuccess: "",
    codeError: "",
    code: "",
    begin: new Date().toISOString().substr(0, 10),
    end: new Date().toISOString().substr(0, 10),
    turnItem: ["Todos", 1, 2, 3, 4, 5, 6],
    turnItems: [1, 2, 3, 4, 5, 6],
    turnSearch: "Todos",
    modalBegin: false,
    modalEnd: false,
    error: false,
    sheetsGeneral: [],
    reportTypeGeneral: "",
    msgError: "",
    search: "",
    msgRemove: "¿Está seguro que desea desactivar al usuario?",
    nameCSV: "Reporte de usuarios" + "-" + new Date().getDate() + "-" + new Date().getMonth() + "-" + new Date().getFullYear() + ".csv",
    headers: [
      {
        text: "Empresa",
        align: "center",
        sortable: true,
        value: "cliente_nombre_comercial",
      },
      {
        text: "Referencia empleado",
        align: "center",
        sortable: true,
        value: "evnp_referencia_empleado",
      },
      {
        text: "Nombre de usuario",
        align: "center",
        sortable: true,
        value: "employee_name",
      },
      {
        text: "Turno",
        align: "center",
        sortable: true,
        value: "turno_id",
      },
      {
        text: "Ruta",
        align: "center",
        sortable: true,
        value: "route_name",
      },
      {
        text: "Ascenso del pasajero",
        align: "center",
        sortable: true,
        value: "fecha_creacion",
      },
    ],
    items: [],
    itemsCSV: [],
    dialogs: {
      remove: false,
    },
    selected: null,
  }),
  mounted() {
    if (this.isReading) {
      this.refresh();
    }
  },
  computed: {
    isReading: function () {
      return services.check(1, this.$route.path);
    },
  },
  methods: {
    refresh() {
      if (this.begin) {
        const fechaFinalOriginal = moment(this.end);
        const fechaFinalNueva = (fechaFinalOriginal.add(1, 'days')).format('YYYY-MM-DD')
        let turnItems = [1, 2, 3, 4, 5, 6]
        let auxTurnSearch = "";
        if (this.turnSearch == 'Todos') {
          auxTurnSearch = turnItems
        } else {
          auxTurnSearch = this.turnSearch
        }
        let data = {
          data: {
            fecha_inicio: this.begin + "T06:00:00.000Z",
            fecha_fin: fechaFinalNueva + "T05:59:59.000Z",
            turno_id: auxTurnSearch 
          },
        };
        if (this.turnSearch) {
          data.data.turno_id = auxTurnSearch;
        }
        this.loading = true;
        services
          .ws("post", "attendanceProgram", data)
          .then((res) => {
            this.items = res.data;
            for (let i = 0; i < this.items.length; i++) {
              this.items[i].fecha_creacion = moment_tz.utc(this.items[i].fecha_creacion).local().format("YYYY-MM-DD HH:mm");
            }
            this.reportTypeGeneral = "Pasajeros y Rutas";
            this.sheetsGeneral = [
              {
                name: "Reporte de Pasajeros y Rutas",
                data: [{}],
              },
            ];
            if (this.items.length > 0) {
              this.sheetsGeneral[0].data.shift();
            }
            for (let i = 0; i < this.items.length; i++) {
              let obj = {
                Empresa: this.items[i].cliente_nombre_comercial ? this.items[i].cliente_nombre_comercial : "",
                "Referencia empleado": this.items[i].evnp_referencia_empleado ? this.items[i].evnp_referencia_empleado : "",
                "Nombre de usuario":
                  (this.items[i].nombre_empleado ? this.items[i].nombre_empleado : "") +
                  " " +
                  (this.items[i].apellido_empleado ? this.items[i].apellido_empleado : "") +
                  " " +
                  (this.items[i].apellido_materno ? this.items[i].apellido_materno : ""),
                Turno: this.items[i].turno_id ? this.items[i].turno_id : "",
                Ruta:
                  this.items[i].ruta_idruta +
                  " " +
                  this.items[i].ruta_nombre_ruta +
                  " " +
                  (this.items[i].servicio != "" ? (this.items[i].tipo_servicio == "M" ? "Mete" : "Saca") : ""),
                "Ascenso del pasajero": this.items[i].fecha_creacion ? this.items[i].fecha_creacion : "",
              };
              this.sheetsGeneral[0].data.push(obj);
            }
          })
          .catch((error) => {
            this.error = true;
            this.codeError = error.response.data.code;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.error = true;
        this.msgError = "Verifique las fechas de inicio y fin";
      }
    },
    dataCSV() {
      if (this.begin) {
        this.itemsCSV = this.items;
        for (let i = 0; i < this.itemsCSV.length; i++) {
          if (this.itemsCSV[i].registered == true) {
            this.itemsCSV[i].registered = "Activo";
          } else {
            this.itemsCSV[i].registered = "Inactivo";
          }
        }
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } else {
        this.itemsCSV = [];
        this.error = true;
        this.codeError = "NO_FILTTER";
      }
    },
    date(value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
    remove(item) {
      if (!this.dialogs.remove) {
        this.itemDelete = item;
        this.selected = JSON.parse(JSON.stringify(item));
        this.dialogs.remove = true;
      } else {
        this.item = null;
        this.loading = true;
        let data = {
          data: {
            idusuario_externo: this.selected,
          },
        };
        services
          .ws("delete", "deleteCode", data)
          .then((res) => {
            this.cancel();
            this.refresh();
            this.success = true;
            this.msgSuccess = "Cliente eliminada correctamente";
          })
          .catch((error) => {
            this.error = true;
            this.codeError = error.response.data.code;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    cancel() {
      this.dialogs.remove = false;
    },
    closeMsg() {
      this.error = false;
    },
    noAccessReport() {
      this.$router.push("/client/reporteDeNoAcceso");
    },
  },
};
</script>

<style scoped></style>
